const ENV = {
    REACT_APP_AUTH_SERVER_URL: process.env.REACT_APP_AUTH_SERVER_URL,
    REACT_APP_REALM: process.env.REACT_APP_REALM,
    REACT_APP_RESOURCE: process.env.REACT_APP_RESOURCE,
    REACT_APP_SERVER_URL: process.env.REACT_APP_SERVER_URL,
}

export default ENV
